import React from "react";
import styles from "./VendingTokenDetail.module.scss";
import { CopyIcon } from "../../../../../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { handleCopy } from "../../../../../../utils";
import { TransactionCategory } from "../../../../../../model/transaction";
import { useLazyDownloadTransactionInvoiceQuery } from "../../../../../../service/transaction-service";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../../../../../utils/error-handler";

interface VendingTokenContext {
	token: string;
	transactionReference: string;
}

interface VendingTokenDetailProps {
	context: VendingTokenContext;
}

const VendingTokenDetail: React.FC<VendingTokenDetailProps> = ({ context }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [downloadInvoice, { isFetching: isDownloading }] = useLazyDownloadTransactionInvoiceQuery();

	const handleDownloadReceipt = () => {
		downloadInvoice(context.transactionReference)
			.unwrap()
			.then(res => {
				if (res) {
					const link = document.createElement("a");
					link.href = res;
					const urlParts = res.split("/");
					const filename = urlParts.at(-1) || `transaction-${context.transactionReference}.pdf`;
					link.download = filename;
					link.target = "_blank";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					toast.success(t("history.web.receiptDownloadedSuccessfully"));
				}
			})
			.catch(err => {
				toast.error(getErrorMessage(err?.data));
			});
	};

	return (
		<div className={styles.container}>
			<div className={styles.successHeader}>
				<div className={styles.successIcon}>
					<svg width="32" height="32" viewBox="0 0 32 32" fill="none">
						<path d="M6 16L13 23L26 9" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</div>
				<h2 className={styles.successTitle}>{t("payment.transactionComplete")}</h2>
				<p className={styles.successSubtitle}>{t("payment.transactionCompleteText")}</p>
			</div>

			<div className={styles.tokenCard}>
				<div className={styles.tokenCardHeader}>
					<span className={styles.label}>{t("buyElectricity.hereIsYourToken")}</span>
					<button className={styles.copyBtn} onClick={() => handleCopy(context.token)} aria-label="Copy token">
						<CopyIcon />
					</button>
				</div>
				<div className={styles.tokenBox}>
					<span className={styles.token}>{context.token}</span>
				</div>
			</div>

			<div className={styles.btnRow}>
				<button className={styles.btn} onClick={handleDownloadReceipt} disabled={isDownloading}>
					{isDownloading ? t("buyElectricity.bulk.downloading") : t("payment.downloadReceipt")}
				</button>
				<button
					className={styles.btn}
					onClick={() => navigate(`/history/${context.transactionReference}`, { state: { category: TransactionCategory.VendingTransaction } })}
				>
					{t("payment.viewTransaction")}
				</button>
			</div>
		</div>
	);
};

export default VendingTokenDetail;
